import Vue from 'vue';
import Router from 'vue-router';
// @ts-ignore
import HomePage from '@/views/Home.vue';
// Partials
// @ts-ignore
import RomaHeader from '@/components/commons/RomaHeader.vue';
// @ts-ignore
import RomaFooter from '@/components/commons/RomaFooter.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: '*', component: HomePage }, // 404 page not found
        {
            path: '/',
            name: 'home',
            redirect: 'organizer',
            meta: {
              text: 'home',
            },
            components: {
                header: RomaHeader,
                default: HomePage,
                footer: RomaFooter,
            },
            children: [
                {
                    path: '/organizer', // Sin el slash obliga a pasar por el path de su padre
                    name: 'organizer',
                    // route level code-splitting
                    // this generates a separate chunk (organizer.[hash].js) for this route
                    // which is lazy-loaded when the route is visited.
                    meta: {
                        text: 'unitList',
                    },
                    component: (resolve) => require(['@/views/Organizer.vue'], resolve),
                    children: [
                        {
                            path: 'unit/:id',
                            name: 'organizer-unit',
                            meta: {
                                text: 'unit',
                                idInText: true,
                            },
                            component: (resolve) => require(['@/views/organizer/Unit.vue'], resolve),
                        },
                        {
                            path: 'advance/:id',
                            name: 'organizer-advance',
                            meta: {
                                text: 'advance',
                                idInText: true,
                            },
                            component: (resolve) => require(['@/views/organizer/Advance.vue'], resolve),
                        },
                    ],
                },
            ],
        },
    ],
});
